import { render, staticRenderFns } from "./CmsResourceDetails.vue?vue&type=template&id=c5c19482&"
import script from "./CmsResourceDetails.vue?vue&type=script&lang=js&"
export * from "./CmsResourceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports